module.exports = __webpack_public_path__ + "img/login.519c8d08.png";